var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',{staticClass:"h-100"},[_c('GlobalErrorPopup'),(_vm.$route.meta.hideToolbar === undefined)?_c('Toolbar'):_vm._e(),_c('div',{staticClass:"h-100 d-flex",class:{
        'padding-under-toolbar': _vm.$route.meta.hideToolbar === undefined,
      }},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }